"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUDIT_ACTOR_TYPES = exports.AUDIT_OUTCOMES = void 0;
/**
 * Audit vocabulary shared across every bounded context that records or
 * reads the platform's audit trail (SL-0031). Mirrors `scope-type.ts`'s
 * precedent: a single authoritative `as const` array plus a derived union
 * type, consumed by `platform/core-api`'s own audit module.
 *
 * Resource/action strings (`AuditMetadata.resource`/`.action`, `core-api`'s
 * `audit/interface/audit.decorator.ts`) are deliberately NOT enumerated
 * here (Resolution 7 of SL-0031) — an audited surface's resource/action
 * vocabulary grows with every new endpoint across every future module, and a
 * centrally-maintained closed list would become an authoring bottleneck.
 * Each `@Audit(...)` call site names its own resource/action string; only
 * the outcome and actor-type vocabularies (fixed, small, cross-cutting) are
 * shared here.
 */
exports.AUDIT_OUTCOMES = ['allowed', 'denied', 'error'];
exports.AUDIT_ACTOR_TYPES = ['user', 'service'];
//# sourceMappingURL=audit-vocabulary.js.map